<div class="row mb-3">
    <div class="col-12 ">
        <h4 class="m-0 p-2 bg-light shadow-sm">
            <ng-content></ng-content>
        </h4>
    </div>
</div>